import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Bell, Repeat, MessageSquare, Star, Info } from "lucide-react";

const icons = { offer: Repeat, chat: MessageSquare, review: Star, info: Info };

export const NotificationBell = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items); setUnread(data.unread);
    } catch (e) {}
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [load]);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const openPanel = async () => {
    setOpen(!open);
    if (!open && unread > 0) {
      await api.post("/notifications/read-all").catch(() => {});
      setUnread(0);
    }
  };

  const click = (n) => {
    setOpen(false);
    if (n.link) navigate(n.link);
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notif-bell" onClick={openPanel} className="relative flex items-center px-2 py-2 hover:text-[#E6B31E] transition-colors">
        <Bell size={18} strokeWidth={2.5} />
        {unread > 0 && (
          <span data-testid="notif-count" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 bg-[#E6B31E] text-black text-[10px] font-extrabold rounded-full flex items-center justify-center border border-black">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto bg-white text-black nb-border rounded-xl nb-shadow-lg z-50">
          <div className="px-4 py-3 border-b-2 border-black font-display font-extrabold text-sm sticky top-0 bg-white">Notifications</div>
          {items.length === 0 ? (
            <div className="p-6 text-center text-black/40 font-semibold text-sm">You're all caught up.</div>
          ) : (
            items.map((n) => {
              const Icon = icons[n.type] || Info;
              return (
                <button key={n.id} data-testid={`notif-item-${n.id}`} onClick={() => click(n)}
                  className={`w-full text-left flex items-start gap-3 px-4 py-3 border-b border-black/5 hover:bg-[#FBF7E9] transition-colors ${!n.read ? "bg-[#FBF7E9]/60" : ""}`}>
                  <span className="w-8 h-8 rounded-lg bg-black text-[#E6B31E] flex items-center justify-center flex-shrink-0"><Icon size={15} strokeWidth={2.5} /></span>
                  <span className="text-sm font-medium leading-snug">{n.text}</span>
                </button>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};
